export enum SupplierJobChannel {
  AllAvailable,
  Directed,
  JobAlerts,
  Watched,
  Rejected,
  GV_AllAvailable = 5,
  GV_Directed = 6,
  GV_JobAlerts = 7,
  GV_Watched = 8,
  GV_Rejected = 9,
  InteractiveSchedule = 10,
}
